module.exports = __webpack_public_path__ + "static/media/img_warning.3fb96adf.svg";